module.exports = __webpack_public_path__ + "static/img/concat.a20adcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/foot/concat.png
// module id = kt26
// module chunks = 7